import { TransactionType } from 'src/interfaces/banking';

export const ACTION_BUTTON_TYPES = [
  TransactionType.Swap,
  // TODO: Re-enable after MVP
  // TransactionType.Transfer
  TransactionType.Deposit,
  TransactionType.Withdraw
];
